<div
    class="flex flex-column justify-content-center align-items-center w-full md:px-3 pb-3"
>
    <div class="w-full flex justify-content-center">
        <div class="w-full max-w-28rem border-round overflow-hidden">
            <img
                src="/assets/images/modals/expired-deals-modal-400.webp"
                alt="Expired Deals"
                class="w-full block"
            />
        </div>
    </div>
    <h2 class="text-center">Your deals just expired<br />Lets fix that.</h2>
    <span class="text mb-3"
        >Deals move fast. The ones in your dashboard have already been booked or
        expired.
    </span>
    <span class="text mb-3"
        ><span class="font-bold">The good news:</span> we add new deals every
        few days, so check back tomorrow.
    </span>
    <span class="text"
        >For now, add more departure airports to unlock more (and better) deals.
    </span>
    <div class="w-full grid mt-4">
        <div class="col-12 py-2 px-0">
            <p-button
                label="Add Airports"
                styleClass="learn-btn w-full"
                severity="info"
                (click)="openDepartures()"
            ></p-button>
        </div>
    </div>
</div>
